/**
 * Created by ssh on 2018/12/19
 * description: axios请求全局配置
 **/
import qs from 'qs'
import axios from 'axios'
import config from './config'
import util from '../common/utils';

// // 基地址
// config.baseURL = BASE_URL;
const apiBaseUrl = process.env.VUE_APP_APIURL;
const authApiBaseUrl = process.env.VUE_APP_AUTH_APIURL;
const bigDataApiBaseUrl = process.env.VUE_APP_BIG_DATA_APIURL;
const websiteApiBaseUrl = process.env.VUE_APP_WEBSITE_APIURL;
const service = axios.create(config);

const productionAuthPaths = [
    '/userMgr/baselogin/getUserInfoByToken',
    '/userMgr/baselogin/getLoginUserInfo',
    '/base/baselogin/login'
];

const resolveBaseUrl = (url, baseUrl) => {
    if (baseUrl) {
        return baseUrl;
    }
    if (productionAuthPaths.includes(url)) {
        return authApiBaseUrl || apiBaseUrl;
    }
    if (url.startsWith('/stats/')) {
        return bigDataApiBaseUrl || apiBaseUrl;
    }
    if (url.startsWith('/website/')) {
        return websiteApiBaseUrl || apiBaseUrl;
    }
    return apiBaseUrl;
};

// 请求拦截
service.interceptors.request.use((config) => {
    const queryToken = util.getQueryString("token");
    const token = queryToken || util.getCookie("token");
    if (token) { // 判断是否存在token，如果存在的话，则每个http header都加上token
        config.headers.token = token;
    }

    if (config.method === 'post') {
        config.data = qs.stringify(config.data);
    }
    return config;

}, (error) => {
    return Promise.reject(error);
});

// 返回状态判断
service.interceptors.response.use((res) => {
    //判断接口返回类型是否是字符串
    if (typeof (res.data) == 'string') {
        return Promise.resolve(res.data);
    }
    let _data = '';
    switch (res.data.code) {
        case 0:
            _data = res.data.data;
            break;
        case 1:
            _data = res.data.data;
            break;
        case -1:
            console.error(`请求失败: ${res.config.url} ${JSON.stringify(res.config.params)}`);
            console.error(`失败原因: ${res.data.msg}`);
            _data = Promise.reject(res.data);
            break;
        case 1001:
            _data = res.data.code;
            break;
        case -2:
            _data = res.data.code;
            break;
        default:
            _data = Promise.reject(res.data);
            break;
    }
    return _data;
}, (error) => {
    if (!error.response) {
        error.message = '请求超时,请检查网络是否正常连接';
        return Promise.reject(error);
    }
    // 404等问题可以在这里处理
    switch (error.response.status) {
        case 400:
            error.message = '请求错误'
            break;

        case 401:
            error.message = '未授权，请登录'
            ssoClient.login(
                process.env.VUE_APP_APPID
            );
            break;

        case 402:
            error.message = '登录过期，请重新登录'
            break;

        case 403:
            error.message = '拒绝访问'
            break;

        case 404:
            error.message = `请求地址出错: ${error.response.config.url}`
            break;

        case 408:
            error.message = '请求超时';
            break;

        case 500:
            error.message = '服务器内部错误'
            break;

        case 501:
            error.message = '服务未实现'
            break;

        case 502:
            error.message = '网关错误'
            break;

        case 503:
            error.message = '服务不可用'
            break;

        case 504:
            error.message = '网关超时'
            break;

        case 505:
            error.message = 'HTTP版本不受支持'
            break;
        default:
            error.message = '服务不可用'
            break;
    }
    console.error(error.message);
    return Promise.reject(error);
});

// 通用方法
export const POST = (url, params, baseUrl) => {
    url = resolveBaseUrl(url, baseUrl) + url;
    return service({
        method: 'post',
        url,
        data: params
    })
}

export const GET = (url, params, baseUrl) => {
    url = resolveBaseUrl(url, baseUrl) + url;
    return service({
        method: 'get',
        url,
        params
    })
}

export const DELETE = (url, params, baseUrl) => {
    url = resolveBaseUrl(url, baseUrl) + url;
    return service({
        method: 'delete',
        url,
        params
    })
}

// 用于mock拦截请求
export function FETCH(url, params) {
    // return new Promise((resolve, reject) => {
    //     axios.post(url, params)
    //         .then(response => {
    //             resolve(response.data);
    //         })
    //         .catch((error) => {
    //             reject(error);
    //         })
    // })
    return axios.post(url, qs.stringify(params)).then(res => res.data)
}
